import React, { PureComponent } from 'react';
import createStyledComponent from '../utils/createStyledComponent.js';
import * as styles from './styles/index.js';
import Button from '../Button/index.js';
import Form from '../Form/index.js';
const DialogWrapper = createStyledComponent(styles);
function isForm(rest) {
    return rest.schema !== undefined;
}
export default class Dialog extends PureComponent {
    constructor() {
        super(...arguments);
        this.onSubmit = () => {
            if (this.submitButton)
                this.submitButton.click();
            else
                this.props.onSubmit();
        };
        this.getFormButtonRef = (node) => {
            this.submitButton = node;
        };
        this.onKeyDown = (e) => {
            if (e.keyCode === 27 /* esc */) {
                e.preventDefault();
                this.props.onDismiss(false);
            }
        };
    }
    render() {
        const { modal, open, fullWidth, title, children, actions, noHeader, noFooter, submitText, onDismiss, ...rest } = this.props;
        const schema = rest.schema;
        return (React.createElement(DialogWrapper, { open: open, fullWidth: fullWidth, onKeyDown: this.onKeyDown, theme: rest.theme },
            React.createElement("div", { onClick: !modal ? onDismiss : undefined }),
            React.createElement("div", null,
                !noHeader && (React.createElement("div", { className: "mc-dialog--header" },
                    React.createElement("div", null, schema ? schema.title || title : title),
                    !modal && React.createElement("button", { onClick: onDismiss }, "\u00D7"))),
                React.createElement("div", { className: "mc-dialog--body" },
                    children,
                    isForm(rest) && (React.createElement(Form, { ...rest }, !noFooter && (React.createElement("input", { type: "submit", ref: this.getFormButtonRef, className: "mc-dialog--hidden" }))))),
                !noFooter &&
                    (actions ? (React.createElement("div", { className: "mc-dialog--footer" }, submitText
                        ? [
                            ...actions,
                            React.createElement(Button, { key: "default-submit", primary: true, onClick: this.onSubmit }, submitText),
                        ]
                        : actions)) : (React.createElement("div", { className: "mc-dialog--footer" },
                        React.createElement(Button, { onClick: onDismiss }, "Cancel"),
                        React.createElement(Button, { primary: true, onClick: this.onSubmit }, submitText || 'Submit')))))));
    }
}
